import React, { useEffect } from "react";
import SelectWithSearch from "components/common/atoms/SelectWithSearch";
import { t } from "components/CentralDataMangement/translation/Translation";
import { useFormContext } from "../../context/Context";
import AutoCompleteDropdown from "components/common/atoms/AutoCompleteDropdown";
import {
  ADMIN,
  CENTRAL_DATA_MANAGEMENT_MICROSERVICE,
  COMPANY_MICROSERVICE,
  SUPER_ADMIN,
} from "Constants";
import { LabelWithInputField } from "components/common/molecules/LabelWithInputField";
import Calender from "components/common/molecules/Calender";
import {
  BASIC_DETAILS,
  BILLING_DETAILS,
  REMENUARATION_DETAILS,
  SET_DROPDOWN_DATA,
  UPDATE_FIELDS,
  UPDATE_FIELD_ERROR,
} from "../../annotation/PlanningConstants";
import {
  fetchCompanyDetails,
  setPCRelatedDetails,
  setPlanningProfileRelatedFields,
} from "../form-data/SetCompanyRelatedData";
import {
  resetCoeffDetails,
  resetCompanyRelatedFields,
  resetLocationRelatedFields,
  resetPayProfileDetails,
  resetPlanningProfileRelatedFields,
  resetCommercialProfileDetails,
  resetShiftDetails,
} from "../form-data/ResetPlanningData";
import { fetchCoeffDetails } from "../form-data/SetCoeffData";
import { fetchProfileDetails } from "../form-data/SetProfileData";
import { getNextSunday } from "components/common/utlis/PlanningUtility";
import { validateField } from "../form-navigation/PlanningFieldValidation";
import { fetchRelocationDetails } from "../form-data/SetRelocationDetails";
import { setTrailPeriod } from "../form-data/setTrialPeriod";
import { useSelector } from "react-redux";
import { selectAuth } from "features/auth/AuthSlice";
import { setParitarCommitteDropdown } from "../form-data/helper";
import { useParams } from "react-router-dom";

const BasicTab: React.FC = () => {
  const { state, dispatch, isViewMode } = useFormContext();
  const authUser = useSelector(selectAuth);
  const { planningId } = useParams<{ planningId: string }>();

  const handleSelectChange = (selectedOption: any, fieldName: string) => {
    if (isViewMode) {return;}
    dispatch({
      type: UPDATE_FIELDS,
      tab: BASIC_DETAILS,
      field: fieldName,
      value: selectedOption,
    });
    validateField(
      fieldName,
      selectedOption,
      state.basicDetails,
      dispatch,
      true
    );

    if (
      fieldName == "office" &&
      selectedOption?.value !== undefined &&
      selectedOption?.value !== null
    ) {
      //Set the pc according to the office
      setParitarCommitteDropdown(
        selectedOption,
        state.dropDowndata.pcLists,
        dispatch
      );
    }

    // Fetch company information when customer is selected
    if (
      fieldName === "customer" &&
      selectedOption?.value !== undefined &&
      selectedOption?.value !== null
    ) {
      fetchCompanyDetails(
        "company",
        selectedOption.value,
        dispatch,
        "create",
        state.basicDetails.office
      ); // Set data related to company details
    } else if (fieldName === "customer") {
      resetCompanyRelatedFields(dispatch); // Reset only company fields, not location fields
      resetCommercialProfileDetails(dispatch, true); //reset
      resetPayProfileDetails(dispatch, true);
      resetShiftDetails(dispatch, true);
      resetPlanningProfileRelatedFields(state, dispatch, "partiarCommittee");
    }

    if (
      fieldName === "collegue" &&
      selectedOption?.value !== undefined &&
      selectedOption?.value !== null
    ) {
      fetchRelocationDetails(
        state.basicDetails.partiarCommittee?.value,
        state.basicDetails.branch?.value,
        selectedOption?.value,
        dispatch,
        false,
        true,
        state.remenurationDetails.typeOfTransport?.value,
        planningId,
        undefined,
        state.generalDetails
      );
    }

    // Fetch location information when branch is selected
    if (
      fieldName === "branch" &&
      selectedOption?.value !== undefined &&
      selectedOption?.value !== null
    ) {
      fetchCompanyDetails(
        "branch",
        selectedOption.value,
        dispatch,
        "create",
        state.basicDetails.office
      ); //Set data related to location details
      // fetchRelocationDetails(state.basicDetails.partiarCommittee?.value,
      //   selectedOption?.value,
      //   state.basicDetails.collegue?.value,
      //   dispatch, false, false, state.remenurationDetails.typeOfTransport?.value, planningId);
    } else if (fieldName === "branch") {
      resetLocationRelatedFields(dispatch); // Only reset location-related fields
    }

    //employeeType
    if (
      fieldName === "employeeType" &&
      selectedOption?.value !== undefined &&
      selectedOption?.value !== null
    ) {
      fetchCoeffDetails("coeff", selectedOption.value, dispatch);
    } else if (fieldName === "employeeType") {
      resetCoeffDetails(dispatch);
    }

    if (fieldName === "planningProfile" || fieldName === "partiarCommittee") {
      resetPlanningProfileRelatedFields(state, dispatch, fieldName);
      fieldName === "partiarCommittee"
        ? resetCommercialProfileDetails(dispatch, true)
        : resetCommercialProfileDetails(dispatch); //reset
      resetPayProfileDetails(dispatch, true);
    }
    // partiarCommittee
    if (
      fieldName === "partiarCommittee" &&
      selectedOption?.value !== undefined &&
      selectedOption?.value !== null
    ) {
      setPCRelatedDetails(selectedOption.value, state, dispatch);
      fetchRelocationDetails(
        selectedOption?.value,
        state.basicDetails.branch?.value,
        state.basicDetails.collegue?.value,
        dispatch,
        true,
        false,
        state.remenurationDetails.typeOfTransport?.value,
        planningId,
        undefined,
        state.generalDetails
      );
    }

    // planningProfile
    if (
      fieldName === "planningProfile" &&
      selectedOption?.value !== undefined &&
      selectedOption?.value !== null
    ) {
      // Updating the commercial profile in the billing tab
      dispatch({
        type: UPDATE_FIELDS,
        tab: BILLING_DETAILS,
        field: "commercialProfile",
        value: selectedOption,
      });

      const timeTableOptions =
        state.dropDowndata.timeTableOptionsWithCoopAgreeId.filter(
          (option: any) =>
            option.cooperationAgreementUnitId ===
            (selectedOption?.agreementId ?? null)
        );

      fetchProfileDetails(
        "planningProfile",
        selectedOption.value,
        state,
        dispatch
      );
      setPlanningProfileRelatedFields(selectedOption?.value, state, dispatch);

      // check is there payProfile option for planning profile
      const payProfileOption = state.dropDowndata.payProfileOptions.find(
        (option: any) =>
          option.empTypeId === selectedOption.empTypeId &&
          selectedOption?.agreementId === option?.agreementId &&
          selectedOption.pcId == option.pcId
      );

      //FIlter the payProfile details
      const filteredPayProfileOptions =
        state.dropDowndata.payProfileOptions.filter(
          (option: any) => option.agreementId == selectedOption?.agreementId
        );

      dispatch({
        type: SET_DROPDOWN_DATA,
        payload: {
          timeTableOptions,
          pcPayProfileOptions: filteredPayProfileOptions,
        },
      });

      //if exists
      if (payProfileOption) {
        dispatch({
          type: UPDATE_FIELDS,
          tab: REMENUARATION_DETAILS,
          field: "payProfile",
          value: payProfileOption,
        });
        fetchProfileDetails(
          "payProfile",
          payProfileOption.value,
          state,
          dispatch
        );
      }
    }
    //if reason
    if (fieldName === "reason") {
      dispatch({ type: UPDATE_FIELD_ERROR, field: "attempt", error: "" });
      dispatch({
        type: UPDATE_FIELDS,
        tab: BASIC_DETAILS,
        field: "attempt",
        value: 0,
      });
    }
  };

  const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isViewMode) {return;}

    const { name, value } = event.target;
    dispatch({
      type: UPDATE_FIELDS,
      tab: BASIC_DETAILS,
      field: name,
      value: value,
    });
    validateField(name, value, state.basicDetails, dispatch, true);
  };

  const handleDateChange = (date: Date | null, name: string) => {
    if (isViewMode) {return;}
    dispatch({
      type: UPDATE_FIELDS,
      tab: BASIC_DETAILS,
      field: name,
      value: date,
    });
    if (name == "from") {
      dispatch({
        type: UPDATE_FIELDS,
        tab: BASIC_DETAILS,
        field: "to",
        value: null,
      });
    }
    validateField(name, date, state.basicDetails, dispatch, true);

    //set the trial period based on days and first contract
    if (name == "to" && state.basicDetails.from && planningId === undefined) {
      setTrailPeriod(state.basicDetails.from, date, dispatch);
    }
  };

  const isValidMonth = (
    date: Date,
    from: Date | null,
    to: Date | null
  ): boolean => {
    const referenceDate = from || to; // Prefer 'from' if exists, else use 'to'

    if (!referenceDate) {return true;} // Allow selection if no reference date

    return (
      date.getMonth() === referenceDate.getMonth() &&
      date.getFullYear() === referenceDate.getFullYear()
    );
  };

  useEffect(() => {
    if (
      state.basicDetails?.partiarCommittee &&
      state.dropDowndata?.commercialProfileOptions &&
      state.dropDowndata.commercialProfileOptions.length > 0
    ) {
      const pcCommercialProfileOptions =
        state.dropDowndata.commercialProfileOptions.filter((option: any) => {
          return option?.pcId == state.basicDetails?.partiarCommittee?.value;
        });
      dispatch({
        type: SET_DROPDOWN_DATA,
        payload: { pcCommercialProfileOptions },
      });
    }
  }, [
    state.basicDetails?.partiarCommittee?.value,
    state.dropDowndata.commercialProfileOptions,
  ]);

  const canSelectPastDates =
    authUser.role === ADMIN || authUser.role === SUPER_ADMIN;
  console.log(
    state.internalInfoDetails?.formStatus,
    state.basicDetails.employeeType,
    state.dropDowndata.pcOptions
  );

  return (
    <div
      className={`form-border ${isViewMode ? "form disableform" : "form"}`}
      style={{ paddingBottom: "1vw", marginBottom: "0vw" }}
    >
      <div className="row">
        <div className="col-lg-2">
          <SelectWithSearch
            title={t("Office")}
            isMandatory={true}
            search={true}
            options={state.dropDowndata.officeOptions}
            onChange={(e) => handleSelectChange(e, "office")}
            isMulti={false}
            name="office"
            value={state.basicDetails.office}
            id="office"
            isTranslate={true}
            error={state.errors.office}
            isDisabled={state.internalInfoDetails.formStatus === 1}
          />
        </div>
        <div className="col-lg-2">
          <LabelWithInputField
            isMandatory={false}
            name="contractNumber"
            handleChange={handleFieldChange}
            value={state.basicDetails.contractNumber}
            id="contractNumber"
            label={t("Contract number")}
            isDisabled={true}
          />
        </div>
        <div className="col-lg-2 autoCompleteFunction">
          <AutoCompleteDropdown
            label={t("Customer")}
            placeholder={t("Type to search") + "..."}
            microService={COMPANY_MICROSERVICE}
            onChange={(e) => handleSelectChange(e, "customer")}
            value={state.basicDetails.customer}
            columnName="company_name"
            modelKey="company"
            id="company"
            isMandatory={true}
            name="customer"
            filter={true}
            filterInfo={[
              // { column: "company_status", value: 1, condition: "where" },
              // { column: "company_status", value: 0, condition: "orWhere" },
              { column: "is_contract_ready", value: 1, condition: "orWhere" },
            ]}
            notNullColumn="bbright_id"
            error={state.errors.customer}
            isDisabled={state.internalInfoDetails.formStatus === 1}
            // isDisabled={!!companyId}
          />
        </div>
        <div className="col-lg-2">
          <SelectWithSearch
            title={t("Branch")}
            isMandatory={true}
            search={true}
            options={state.dropDowndata.branchOptions}
            onChange={(e) => handleSelectChange(e, "branch")}
            isMulti={false}
            name="branch"
            value={state.basicDetails.branch}
            id="branch"
            isTranslate={true}
            error={state.errors.branch}
            // isDisabled={state.internalInfoDetails.formStatus === 1}
          />
        </div>
        <div className="col-lg-2 autoCompleteFunction">
          <AutoCompleteDropdown
            label={t("Employee")}
            placeholder={t("Type to search") + "..."}
            microService={CENTRAL_DATA_MANAGEMENT_MICROSERVICE}
            onChange={(e) => handleSelectChange(e, "collegue")}
            value={state.basicDetails.collegue}
            modelKey={"contractReadyCandidates"}
            customFetch={true}
            columnName=""
            isMultiSelect={false}
            name="collegue"
            notNullColumn="bbright_id"
            error={state.errors.collegue}
            isMandatory={true}
            isDisabled={state.internalInfoDetails.formStatus === 1}
          />
        </div>
        <div className="col-lg-2">
          <SelectWithSearch
            title={t("Paritair committee")}
            isMandatory={true}
            search={true}
            // options={state.dropDowndata.pcOptions}
            options={
              state.internalInfoDetails?.formStatus === 1
                ? state.dropDowndata?.pcOptions.filter(
                    (option) =>
                      option.type === state.basicDetails?.employeeType?.type
                  )
                : state.dropDowndata?.pcOptions
            }
            onChange={(e) => handleSelectChange(e, "partiarCommittee")}
            isMulti={false}
            name="partiarCommittee"
            value={state.basicDetails.partiarCommittee}
            id="partiarCommittee"
            isTranslate={true}
            error={state.errors.partiarCommittee}
            // isDisabled={state.internalInfoDetails.formStatus === 1}
          />
        </div>
        <div className="col-lg-2">
          <SelectWithSearch
            title={t("Commercial profile")}
            isMandatory={true}
            search={true}
            options={state.dropDowndata.pcCommercialProfileOptions}
            onChange={(e) => handleSelectChange(e, "planningProfile")}
            isMulti={false}
            name="planningProfile"
            value={state.basicDetails.planningProfile}
            id="planningProfile"
            isTranslate={true}
            error={state.errors.planningProfile}
            // isDisabled={state.internalInfoDetails.formStatus === 1}
          />
        </div>
        <div className="col-lg-2">
          <SelectWithSearch
            title={t("Employee type")}
            isMandatory={true}
            search={true}
            options={state.dropDowndata.employeeTypeOptions}
            onChange={(e) => handleSelectChange(e, "employeeType")}
            isMulti={false}
            name="employeeType"
            value={state.basicDetails.employeeType}
            id="employeeType"
            isTranslate={true}
            error={state.errors.employeeType}
            isDisabled={state.internalInfoDetails.formStatus === 1}
          />
        </div>
        <div className="col-lg-2">
          <LabelWithInputField
            isMandatory={true}
            name="function"
            handleChange={handleFieldChange}
            value={state.basicDetails.function}
            id="function"
            label={t("Function")}
            placeholder={t("Function")}
            error={state.errors.function}
            // isDisabled={state.internalInfoDetails.formStatus === 1}
          />
        </div>
        <div className="col-3">
          <div className="row">
            <div className="col-lg-6 position-relative">
              <Calender
                onChange={(date) => handleDateChange(date, "from")}
                selectedDate={state.basicDetails.from}
                label={t("From")}
                name="from"
                // maxDate={state.basicDetails.to}
                isMandatory={true}
                minDate={canSelectPastDates ? null : new Date()} //** pass null who can have right to create contract for past dates */
                error={state.errors.from}
                isDisabled={state.internalInfoDetails.formStatus === 1}
                // filterDate={(date) => isValidMonth(date, state.basicDetails.from, state.basicDetails.to)}
                isViewMode={isViewMode}
              />
            </div>
            <div className="col-lg-6 position-relative">
              <Calender
                onChange={(date) => handleDateChange(date, "to")}
                selectedDate={state.basicDetails.to}
                label={t("To")}
                name="to"
                isMandatory={true}
                minDate={state.basicDetails.from}
                maxDate={
                  state.basicDetails.from
                    ? getNextSunday(new Date(state.basicDetails.from))
                    : getNextSunday(new Date())
                }
                error={state.errors.to}
                // isDisabled={state.internalInfoDetails.formStatus === 1}
                // filterDate={(date) => isValidMonth(date, state.basicDetails.from, state.basicDetails.to)}
                isViewMode={isViewMode}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-2">
          <SelectWithSearch
            title={t("Reason")}
            isMandatory={true}
            search={true}
            options={state.dropDowndata.reasonOptions}
            onChange={(e) => handleSelectChange(e, "reason")}
            isMulti={false}
            name="reason"
            value={state.basicDetails.reason}
            id="reason"
            isTranslate={true}
            error={state.errors.reason}
            // isDisabled={state.internalInfoDetails.formStatus === 1}
          />
        </div>
        {state.basicDetails.reason?.value === 4 && (
          <div className="col-lg-1">
            <LabelWithInputField
              isMandatory={true}
              name="attempt"
              handleChange={handleFieldChange}
              value={state.basicDetails.attempt}
              id="attempt"
              label={t("Attempts")}
              type="number"
              min={1}
              step={1}
              max={3}
              error={state.errors.attempt}
              // isDisabled={state.internalInfoDetails.formStatus === 1}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default BasicTab;
